import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export type TerminalStatus = 'active' | 'disabled' | 'decommissioned';
export type TerminalBillingState = 'open' | 'closed';

/** A terminal row as enriched by GET /terminals. */
export interface Terminal {
  id: string;
  storeId: string;
  terminalNumber: string;
  terminalName: string;
  appVersion: string | null;
  status: TerminalStatus;
  billingState: TerminalBillingState;
  lastSeenAt: string | null;
  lastBillAt: string | null;
  billsTodayCount: number;
  queuedBills: number;
  currentCashierId: string | null;
  online: boolean;
  todaysBillCount: number;
  store?: { id: string; name: string; storeCode: string };
  currentCashier?: { id: string; name: string } | null;
}

@Injectable({ providedIn: 'root' })
export class TerminalsService {
  private apiUrl = environment.apiUrl + '/terminals';

  constructor(private http: HttpClient) {}

  /** List all terminals for the client, optionally scoped to one store. */
  getTerminals(storeId?: string): Observable<Terminal[]> {
    const params: any = {};
    if (storeId) params.storeId = storeId;
    return this.http.get<Terminal[]>(this.apiUrl, { params });
  }

  /** Remotely enable or disable a terminal. */
  updateStatus(
    id: string,
    status: 'active' | 'disabled',
  ): Observable<{ id: string; status: TerminalStatus }> {
    return this.http.patch<{ id: string; status: TerminalStatus }>(
      `${this.apiUrl}/${id}/status`,
      { status },
    );
  }

  /** Stores for the filter dropdown. */
  getStores(): Observable<any> {
    return this.http.get(environment.apiUrl + '/stores');
  }
}
